import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MessageSquare, ArrowRight } from "lucide-react";
import { API } from "../../config";
import { useAuth } from "../../context/AuthContext";

export const daysLeftLabel = (d) =>
  d === null || d === undefined ? "Consumo non ancora disponibile" : `Sufficiente per circa ${d} ${d === 1 ? "giorno" : "giorni"}`;

export const SmsCreditWidget = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [s, setS] = useState(null);
  const allowed = ["admin", "super_admin"].includes(user?.role);

  useEffect(() => {
    if (!allowed) return;
    axios.get(`${API}/admin/sms-credit/summary`).then((r) => setS(r.data)).catch(() => setS(null));
  }, [allowed]);

  if (!allowed || !s) return null;
  const tone = s.exhausted ? "border-red-500/50 bg-red-500/10" : (s.low || s.running_out) ? "border-amber-500/40 bg-amber-500/10" : "border-gray-800 bg-[#111]";
  const valueTone = s.exhausted ? "text-red-400" : (s.low || s.running_out) ? "text-amber-300" : "text-white";

  return (
    <div className={`mb-6 rounded-2xl border p-4 flex items-center gap-4 flex-wrap ${tone}`} data-testid="dashboard-sms-credit-widget">
      <MessageSquare className="text-lojack-red flex-shrink-0" size={22} />
      <div className="flex-1 min-w-[200px]">
        <p className="text-xs uppercase tracking-wider text-gray-400">Credito SMS</p>
        <p className={`text-2xl font-bold ${valueTone}`} data-testid="dashboard-sms-credit-balance">
          € {Number(s.balance_eur).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </p>
      </div>
      <div className="text-sm text-gray-300 min-w-[200px]">
        <p data-testid="dashboard-sms-credit-sms-left">≈ {Number(s.sms_it_left).toLocaleString("it-IT")} SMS Italia</p>
        <p className="text-xs text-gray-400" data-testid="dashboard-sms-credit-days-left">{daysLeftLabel(s.days_left)}</p>
      </div>
      {s.exhausted && <p className="text-xs text-red-300 basis-full sm:basis-auto">Esaurito: SMS ai clienti sospesi, invio solo email</p>}
      <button onClick={() => navigate("/admin/sms-credit")} className="btn-lojack text-sm flex items-center gap-1" data-testid="dashboard-sms-credit-topup-btn">
        Ricarica <ArrowRight size={14} />
      </button>
    </div>
  );
};
